import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EmailChangeAutRequest, EmailChangeAuthResponse, EmailChangeVerify } from '../../entities/email-change.entity';

export const emailChangeActions = createActionGroup({
  source: 'Email Change',
  events: {
    'Start Process': props<{ newEmail: string }>(),
    'Request Tan': props<{ requestId: string }>(),
    Verify: props<{ payload: EmailChangeVerify }>(),
    'Request Auth': props<{ interested: EmailChangeAutRequest }>(),
    'Send Code Old Email': props<{ requestId: string }>(),
    'Verify Old Email': props<{ code: string; requestId: string }>(),
    'Send Code New Email': props<{ requestId: string }>(),
    'Verify New Email': props<{ code: string; requestId: string }>(),
    'Abort Process': props<{ requestId: string }>(),
  },
});

export const emailChangeApiActions = createActionGroup({
  source: 'Email Change API',
  events: {
    'Start Process Success': props<{ requestId: string }>(),
    'Start Process Failure': props<{ error: HttpErrorResponse }>(),
    'Request Tan Success': props<{ interested: boolean }>(),
    'Request Tan Failure': props<{ error: HttpErrorResponse }>(),
    'Verify Success': emptyProps(),
    'Verify Failure': props<{ error: HttpErrorResponse }>(),
    'Request Auth Success': props<{ interested: EmailChangeAuthResponse }>(),
    'Request Auth Failure': props<{ error: HttpErrorResponse }>(),
    'Send Code Old Email Success': emptyProps(),
    'Send Code Old Email Failure': props<{ error: HttpErrorResponse }>(),
    'Verify Old Email Success': props<{ interested: boolean }>(),
    'Verify Old Email Failure': props<{ error: HttpErrorResponse }>(),
    'Send Code New Email Success': emptyProps(),
    'send Code New Email Failure': props<{ error: HttpErrorResponse }>(),
    'Verify New Email Success': props<{ interested: boolean }>(),
    'Verify New Email Failure': props<{ error: HttpErrorResponse }>(),
    'Abort Process Success': emptyProps(),
    'Abort Process Failure': props<{ error: HttpErrorResponse }>(),
  },
});
